import { filterOrgTreeByIds } from "@/features/data-entry/utils/orgTree.helpers";
import { normalizeOrgId } from "@/features/esg/utils/org-scope.utils";

const COMPANY_SCOPE_KEY = "__company__";

export const buildAssignedOrgTree = (disclosure, filteredOrgTree = []) => {
  if (disclosure?.isAllOrganization) return filteredOrgTree;

  const orgIds = Array.isArray(disclosure?.organizationIds)
    ? disclosure.organizationIds
    : [];

  if (!orgIds.length && !disclosure?.isCompanySelected) {
    return filteredOrgTree;
  }

  const allowedSet = new Set(orgIds.map(normalizeOrgId).filter(Boolean));

  if (disclosure?.isCompanySelected) {
    filteredOrgTree.forEach((node) => {
      if (node?.id) allowedSet.add(normalizeOrgId(node.id));
    });
  }

  if (!allowedSet.size) return filteredOrgTree;

  return filterOrgTreeByIds(filteredOrgTree, allowedSet);
};

export const collectAssignedTargetScopeIds = (nodes = []) => {
  const seen = new Set();
  const collected = [];

  const visit = (items = []) => {
    items.forEach((node) => {
      if (!node?.isGroup) {
        if (node?.unitLevel === "parent_company") {
          if (!seen.has(COMPANY_SCOPE_KEY)) {
            seen.add(COMPANY_SCOPE_KEY);
            collected.push(null);
          }
        } else if (node?.id) {
          const id = String(node.id);
          if (!seen.has(id)) {
            seen.add(id);
            collected.push(id);
          }
        }
      }

      if (node?.children?.length) {
        visit(node.children);
      }
    });
  };

  visit(nodes);
  return collected;
};
